AOS.init({
  duration: 1200,
})
// $(document).ready(function() {
//   var stickyTop = $('.product-img-box ').offset().top;

//   $(window).scroll(function() {
//     var windowTop = $(window).scrollTop();

//     if (stickyTop < windowTop) {
//       $('.product-img-box').css('position', 'fixed');
//     } else{
//       $('.product-img-box').css('position', 'relative');
//     }
//   });
// });

if(jQuery(window).width() < 600)
{
   jQuery(document).ready(function(){
  jQuery('.custom-footer-content,.footer-block-title ~ .block_content').hide();
    
  jQuery('.info-footer .widget-wrapper').click(function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active").find(".custom-footer-content,.footer-block-title ~ .block_content").slideUp();
    } else {
      jQuery(".info-footer .widget-wrapper.active .custom-footer-content ,.info-footer .widget-wrapper.active .footer-block-title ~ .block_content").slideUp();
      jQuery(".info-footer .widget-wrapper .custom-footer-content ,.info-footer .widget-wrapper.active .footer-block-title ~ .block_content").removeClass("active");
      jQuery(this).addClass("active").find(".custom-footer-content ,.footer-block-title ~ .block_content").slideDown();
    }
    return false;
  });
  
});
} 



